var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0303 0.46967C11.7374 0.176777 11.2626 0.176777 10.9697 0.46967L8.87777 2.56157C8.87502 2.56424 8.87229 2.56693 8.86957 2.56965C8.86686 2.57236 8.86417 2.57509 8.8615 2.57784L0.46967 10.9697C0.329018 11.1103 0.25 11.3011 0.25 11.5V15C0.25 15.4142 0.585786 15.75 1 15.75H4.5C4.69891 15.75 4.88968 15.671 5.03033 15.5303L15.5303 5.03033C15.8232 4.73744 15.8232 4.26256 15.5303 3.96967L12.0303 0.46967ZM9.39996 4.1607L1.75 11.8107V14.25H4.18934L11.8393 6.60004L9.39996 4.1607ZM12.9 5.53938L13.9393 4.5L11.5 2.06066L10.4606 3.10004L12.9 5.53938Z","fill":"#181818"}));
}

Pencil.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
